// src/utils/getParagraph.tsx
import React, { Suspense } from 'react';
import paragraphComponents from './paragraphRegistry';

type ParagraphTypes = keyof typeof paragraphComponents;

interface Props {
  [key: string]: any;
}

interface Paragraph {
  type: string;
  [key: string]: any;
}

interface GetParagraphProps {
  node: Paragraph;
  props?: Props;
}
export const getParagraph = ({ node, props }: GetParagraphProps): React.ReactElement | null => {
  const ParagraphComponent = paragraphComponents[node.type as ParagraphTypes];
  if (ParagraphComponent) {
    return (
      <Suspense fallback={<>Loading {node.type}...</>}>
        {/* @ts-ignore TODO: fix paragraph typescript */}
        <ParagraphComponent node={node} props={props} />
      </Suspense>
    );
  }
  return null;
};
